import { render } from "./ImportPurchases.vue?vue&type=template&id=7ad40b2c"
import script from "./ImportPurchases.vue?vue&type=script&lang=js"
export * from "./ImportPurchases.vue?vue&type=script&lang=js"

import "./ImportPurchases.vue?vue&type=style&index=0&id=7ad40b2c&lang=css"
script.render = render

export default script